<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl p-5 m-4 h-full">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Well Barrier Schematic Diagram
        </div>

        <form [formGroup]="searchForm">
            <app-table-filter [searchForm]="searchForm" (searchTriggered)="handleSearch($event)"
                class="text-primary"></app-table-filter>

            <div class="grid grid-cols-1 sm:grid-cols-3">
                <div class="col-span-2">
                    <mat-form-field class="ml-2 no-bottom-gap mb-2">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="flex justify-end mb-6">
                    <button class="btn btn-primary mx-2" (click)="getWellSchematicList()">
                        Search
                    </button>
                    <button class="btn btn-outline btn-default" (click)="reset()">
                        Reset
                    </button>
                    <button class="btn btn-outline btn-default mx-2 hover:text-white" (click)="getWellSchematicList()">
                        <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <div *ngIf="wellSchematics.length > 0" class="grid gap-6 w-full
         grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
            <div *ngFor="let wellSchematic of wellSchematics"
                class="shadow-lg p-2 border rounded-2xl cursor-pointer h-full" (click)="viewDashboard(wellSchematic)"
                [ngClass]="{'col-span-full mx-auto max-w-72 w-full': wellSchematics?.length === 1}">
                <div class="flex flex-col">
                    <div class="flex flex-row justify-between p-2">
                        <div>
                            <div class="text-lg">{{ wellSchematic.stringLongName }}</div>
                            <!-- <div class="text-gray-400">{{ wellSchematic.wellLongName }}</div> -->
                            <div class="text-md text-primary">{{ wellSchematic.wellType }}</div>
                        </div>

                        <div *ngIf="wellSchematic.wellHealtinessStatus && wellSchematic.wellHealtinessStatus.includes('Healthy')"
                            class="mt-1 circle successBadge" [matTooltip]="wellSchematic.wellHealtinessStatus"></div>

                        <div *ngIf="wellSchematic.wellHealtinessStatus && wellSchematic.wellHealtinessStatus.includes('Unhealthy')"
                            class="mt-1 circle failedBadge" [matTooltip]="wellSchematic.wellHealtinessStatus"></div>

                        <div *ngIf="!wellSchematic.wellHealtinessStatus">
                            <mat-icon svgIcon="mat_outline:hide_image"></mat-icon>
                        </div>
                    </div>


                    <ng-container *ngIf="wellSchematic.wellSchematicBlob">
                        <img class="w-full h-96 text-center rounded-2xl" [src]="wellSchematic.wellSchematicBlob"
                            alt="Well schematic">
                    </ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="wellSchematics.length > 0" class="join flex justify-between w-full mt-6">
            <button class="join-item btn btn-remove-bg" [disabled]="searchForm.get('Page')?.value <= 1"
                (click)="previousPage()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
                Previous</button>
            <button class="join-item"> {{ searchForm.get('Page')?.value }} / {{ searchForm.get('totalPages')?.value
                }}</button>
            <button class="join-item btn btn-remove-bg"
                [disabled]="searchForm.get('totalPages')?.value <= searchForm.get('Page')?.value" (click)="nextPage()">
                Next
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-right'"></mat-icon>
            </button>
        </div>

        <div *ngIf="wellSchematics.length == 0">
            <div class="flex flex-col items-center justify-center mt-12">
              <mat-icon svgIcon="search_off" style="width: 40px; height: 40px; font-size: 40px;"></mat-icon>
                <div class=" mt-2 text-gray-400 font-semibold text-lg">No Data found</div>
            </div>
        </div>
    </div>
</div>